<div class="flex flex-col px-10 py-4 border-2 rounded-md" [ngClass]="hasError() ? 'border-red-500' : 'border-gray-900/10'">
    <div class="text-lg font-semibold my-1">{{ title() }}</div>
    <div class="py-2">
        @for (lang of langs(); track lang) {
        <div
            class="flex justify-start my-2"
            [ngClass]="richText() ? 'flex-col items-start' : 'flex-row items-center'"
        >
            <div class="text-md font-semibold m-1 p-1 w-10">{{ lang | uppercase }}:</div>

            @if (!richText()) {
                <div class="w-1/4">
                    @if (!textArea()) {
                        <input
                            class="border w-full focus:outline-none rounded-md p-2"
                            type="text"
                            [value]="value()[lang]"
                            (keyup)="setLang(lang, $any($event.target).value)"
                        />
                    }
                    @if (textArea()) {
                        <textarea
                            class="border w-full focus:outline-none rounded-md p-2"
                            [value]="value()[lang]"
                            (keyup)="setLang(lang, $any($event.target).value)"
                        ></textarea>
                    }
                </div>
            }

            @if (richText() && textArea()) {
                <div class="flex flex-row">
                    <valben-rich-text-editor
                        [key]="lang"
                        [value]="value()[lang]"
                        (signal)="setLang($event.key, $event.value)"
                    ></valben-rich-text-editor>
                    <button
                        type="button"
                        (click)="removeLang(lang)"
                        class="valben-icon-button valben-icon-button--compact mx-8"
                        [attr.aria-label]="'Ukloni jezik ' + lang">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            }

            @if (!richText()) {
                <button
                    type="button"
                    (click)="removeLang(lang)"
                    class="valben-icon-button valben-icon-button--compact mx-4"
                    [attr.aria-label]="'Ukloni jezik ' + lang">
                    <mat-icon>close</mat-icon>
                </button>
            }
        </div>
        }

        @if (step === 'idle') {
            <div>
                <div
                    (click)="startAdd()"
                    class="px-8 py-2 border-2 border-valamarblueprimary rounded-md font-semibold hover:bg-valamarblueprimary hover:text-white cursor-pointer w-fit"
                >
                    Novo
                </div>
            </div>
        }

        @if (step === 'pickLang') {
            <div class="flex items-center">
                <div class="card flex justify-content-center py-2">
                    <valben-countries-dropdown
                        [options]="availableCountries()"
                        (signal)="selectCountry($event)"
                    ></valben-countries-dropdown>
                </div>
                <button
                    type="button"
                    (click)="cancelAdd()"
                    class="valben-icon-button mx-2"
                    aria-label="Odustani od dodavanja jezika">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        }

        @if (step === 'enterText') {
            <div class="py-2">
                @if (!textArea()) {
                    <input
                        class="border focus:outline-none rounded-md p-2"
                        type="text"
                        [placeholder]="selectedCountryName"
                        [(ngModel)]="inputedValue"
                    />
                }
                @if (textArea()) {
                    <textarea
                        class="border w-1/3 h-36 focus:outline-none rounded-md p-2"
                        [placeholder]="selectedCountryName"
                        [(ngModel)]="inputedValue"
                    ></textarea>
                }
                <div
                    (click)="confirmAdd()"
                    class="my-2 px-8 py-2 border-2 border-valamarblueprimary rounded-md font-semibold hover:bg-valamarblueprimary hover:text-white cursor-pointer w-fit"
                >
                    Dodaj
                </div>
            </div>
        }
    </div>
</div>
